import faker from 'faker'
import moment from 'moment'
import hres6buLabels from 'assets/labels/hres6bu'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres6buLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        codempid: faker.finance.mask(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        dtework: moment().format('DD/MM/YYYY'),
        codshift: faker.address.stateAbbr(),
        timin_o: faker.date.past().toString().substr(16, 5) + ' - ' + faker.date.past().toString().substr(16, 5),
        timin_n: faker.date.past().toString().substr(16, 5) + ' - ' + faker.date.past().toString().substr(16, 5),
        remark: faker.lorem.words(),
        reason: faker.lorem.words(),
        status: faker.lorem.words(),
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remarkap: faker.lorem.words(),
        desc_codempap: faker.name.findName()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codinput: faker.finance.mask(),
      desc_codinput: faker.name.findName(),
      codempid: faker.finance.mask(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      dtework: moment().format('DD/MM/YYYY'),
      codshift: faker.finance.mask(),
      desc_codshift: faker.name.findName(),
      timin_sch: faker.date.past().toString().substr(16, 5),
      timout_sch: faker.date.past().toString().substr(16, 5),
      dteine: moment().format('DD/MM/YYYY'),
      timine: faker.date.past().toString().substr(16, 5),
      dteoute: moment().format('DD/MM/YYYY'),
      timoute: faker.date.past().toString().substr(16, 5),
      dtein: moment().format('DD/MM/YYYY'),
      timin: faker.date.past().toString().substr(16, 5),
      dteout: moment().format('DD/MM/YYYY'),
      timout: faker.date.past().toString().substr(16, 5),
      codshift2: faker.finance.mask(),
      desc_codshift2: faker.name.findName(),
      timin_sch2: faker.date.past().toString().substr(16, 5),
      timout_sch2: faker.date.past().toString().substr(16, 5),
      dteinr: moment().format('DD/MM/YYYY'),
      timinr: faker.date.past().toString().substr(16, 5),
      dteoutr: moment().format('DD/MM/YYYY'),
      timoutr: faker.date.past().toString().substr(16, 5),
      dtein2: moment().format('DD/MM/YYYY'),
      timin2: faker.date.past().toString().substr(16, 5),
      dteout2: moment().format('DD/MM/YYYY'),
      timout2: faker.date.past().toString().substr(16, 5),
      codreqst: faker.finance.mask(),
      desc_codreqst: faker.name.findName(),
      remark: faker.lorem.word()
    }
    let mockTab2 = {
      codempid: faker.finance.mask(),
      desc_codempid: faker.name.findName()
    }
    let mockTab2Rows = []
    const mockTab2Total = 5
    for (var i = 1; i <= mockTab2Total; i++) {
      mockTab2Rows.push({
        id: i,
        dtework: moment().format('DD/MM/YYYY'),
        typwork: faker.address.stateAbbr().toString().substr(1, 1),
        codshift: faker.address.stateAbbr(),
        timework: faker.date.past().toString().substr(16, 5) + ' - ' + faker.date.past().toString().substr(16, 5),
        dtein: faker.date.past().toString().substr(16, 5),
        dteout: faker.date.past().toString().substr(16, 5)
      })
    }
    let mockTab3 = {
    }

    return {
      tab1: mockTab1,
      tab2: {
        detail: mockTab2,
        table: {
          total: mockTab2Total,
          rows: mockTab2Rows
        }
      },
      tab3: mockTab3
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6bu/mocker.js